const SOURCE_ENV_KEYS = Object.freeze({
  SUPABASE_URL: 'REACT_APP_SUPABASE_URL',
  SUPABASE_ANON_KEY: 'REACT_APP_SUPABASE_ANON_KEY',
  SITE_URL: 'REACT_APP_SITE_URL',
  APP_DEEP_LINK: 'REACT_APP_APP_DEEP_LINK',
  IOS_APP_STORE_URL: 'REACT_APP_IOS_APP_STORE_URL',
  ANDROID_PLAY_STORE_URL: 'REACT_APP_ANDROID_PLAY_STORE_URL',
});

let envConsumptionLogged = false;

const envValueSources = Object.freeze({
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL,
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY,
  SITE_URL: process.env.REACT_APP_SITE_URL,
  APP_DEEP_LINK: process.env.REACT_APP_APP_DEEP_LINK,
  IOS_APP_STORE_URL: process.env.REACT_APP_IOS_APP_STORE_URL,
  ANDROID_PLAY_STORE_URL: process.env.REACT_APP_ANDROID_PLAY_STORE_URL,
});

function readBuildEnv(value) {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
}

function maskValue(value) {
  if (!value) {
    return '';
  }

  if (value.length <= 8) {
    return `${value.slice(0, 2)}***`;
  }

  return `${value.slice(0, 4)}***${value.slice(-4)}`;
}

function buildEnvDiagnostics() {
  return Object.freeze(
    Object.fromEntries(
      Object.entries(SOURCE_ENV_KEYS).map(([name, sourceName]) => {
        const resolvedValue = envValueSources[name];
        const trimmedValue = readBuildEnv(resolvedValue);

        return [
          name,
          Object.freeze({
            sourceName,
            foundInBuildEnv: typeof resolvedValue === 'string' && resolvedValue.length > 0,
            rawLength: typeof resolvedValue === 'string' ? resolvedValue.length : 0,
            presentAfterTrim: trimmedValue.length > 0,
            preview: maskValue(trimmedValue),
          }),
        ];
      })
    )
  );
}

export const env = Object.freeze(
  Object.fromEntries(
    Object.entries(envValueSources).map(([name, value]) => [name, readBuildEnv(value)])
  )
);

export const envDiagnostics = buildEnvDiagnostics();

export function logEnvConsumption(context = 'startup') {
  if (envConsumptionLogged || typeof window === 'undefined') {
    return;
  }

  envConsumptionLogged = true;

  const missingKeys = Object.entries(envDiagnostics)
    .filter(([, details]) => !details.presentAfterTrim)
    .map(([name, details]) => `${name} (${details.sourceName})`);

  if (missingKeys.length > 0) {
    console.warn('[tecniq-web:env] missing or empty environment variables', {
      context,
      missingKeys,
      note:
        'This CRA bundle only sees values that were available at build time. Cloudflare Pages deployment-time vars must be exposed as REACT_APP_* build variables or injected via a runtime config layer.',
    });
  }
}

export { SOURCE_ENV_KEYS };
